addEventListener('turbo:frame-load', function() {
  let selects = document.querySelectorAll('select[name^="work_order"][class*="is-"]')
  if (selects.length > 0) {
    setTimeout(function() {
      selects.forEach(el => el.classList.remove('is-valid', 'is-invalid'))
    }, 2000)
  }
})
